import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import {
  loadLeadSourceTags,
  loadLeadSourceTagsFailure,
  loadLeadSourceTagsSuccess,
} from '../actions/load-lead-source-tags.actions';
import { LeadSourceTagsApiService } from '@core/services/lead-source-tags-api.service';
import { ToastService } from '@shared/services/toast.service';

@Injectable()
export class LoadLeadSourceTagsEffects {
  constructor(
    private actions$: Actions,
    private leadSourceTagsApiService: LeadSourceTagsApiService,
    private toastService: ToastService,
  ) {}

  loadLeadSourceTags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadLeadSourceTags),
      switchMap(() =>
        this.leadSourceTagsApiService.index().pipe(
          map(({ data: leadSourceTags }) => loadLeadSourceTagsSuccess({ leadSourceTags })),
          catchError((error) => of(loadLeadSourceTagsFailure({ error }))),
        ),
      ),
    ),
  );

  loadLeadSourceTagsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadLeadSourceTagsFailure),
        tap(() => {
          this.toastService.showToast('error', 'Failed to load lead source tags. Please try again.');
        }),
      ),
    { dispatch: false },
  );
}
